import { Component, computed, effect, input, type OnDestroy, signal } from '@angular/core';

@Component({
  selector: 'avs-workflow-attempt-timeout',
  templateUrl: './workflow-attempt-timeout.component.html',
})
export class WorkflowAttemptTimeoutComponent implements OnDestroy {
  lastExecutedAt = input.required<string>();
  timeout = input.required<number>();

  remainingTime = signal(0); // seconds
  progress = signal(100); // %

  formattedTime = computed(() => {
    const sec = this.remainingTime();
    const h = Math.floor(sec / 3600);
    const m = Math.floor((sec % 3600) / 60);
    const s = sec % 60;

    return `${h.toString().padStart(2, '0')}h:${m.toString().padStart(2, '0')}m:${s.toString().padStart(2, '0')}s`;
  });

  private intervalId?: ReturnType<typeof setInterval>;

  constructor() {
    effect(() => {
      this.startCountdown(this.lastExecutedAt(), this.timeout());
    });
  }

  ngOnDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  private startCountdown(lastExecutedAt: string, timeout: number) {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }

    const start = new Date(lastExecutedAt).getTime();
    const end = start + timeout * 1000;

    const updateValues = () => {
      const now = Date.now();
      const total = end - start;
      const left = Math.max(0, end - now);

      this.remainingTime.set(Math.floor(left / 1000));
      this.progress.set(Math.max(0, Math.min(100, (left / total) * 100)));

      if (left <= 0 && this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = undefined;
      }
    };

    updateValues();

    this.intervalId = setInterval(updateValues, 1000);
  }
}
